module.exports = __webpack_public_path__ + "img/kiss-fm-uk.83503258.png";